export default {
      id: "ic_won-icon-usage",
      viewBox: "0 0 26 26",
      url: "/" + "images/icons.3.109.2.svg#ic_won-icon-usage",
      toString: function () {
        return this.url;
      }
    }